import type { ComponentConfig } from '@measured/puck';
import { Container } from '../layout/Container';

export interface ComparisonRow {
  feature: string;
  us: string;
  them: string;
}

export interface ComparisonTableProps {
  title?: string;
  ourLabel: string;
  theirLabel: string;
  rows: ComparisonRow[];
}

export function ComparisonTable({
  title,
  ourLabel,
  theirLabel,
  rows,
}: ComparisonTableProps) {
  return (
    <section className="bg-white py-16">
      <Container>
        {title ? <h2 className="mb-6 text-3xl font-bold tracking-tightish">{title}</h2> : null}
        <div className="overflow-x-auto rounded-2xl border border-stone-200">
          <table className="w-full text-left text-sm">
            <thead className="bg-stone-50 text-stone-700">
              <tr>
                <th className="p-4">Critère</th>
                <th className="p-4 text-brand-700">{ourLabel}</th>
                <th className="p-4">{theirLabel}</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row) => (
                <tr key={row.feature} className="border-t border-stone-200">
                  <td className="p-4 font-medium text-stone-900">{row.feature}</td>
                  <td className="p-4 text-brand-700">{row.us}</td>
                  <td className="p-4 text-stone-600">{row.them}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Container>
    </section>
  );
}

export const ComparisonTableConfig: ComponentConfig<ComparisonTableProps> = {
  fields: {
    title: { type: 'text' },
    ourLabel: { type: 'text' },
    theirLabel: { type: 'text' },
    rows: {
      type: 'array',
      arrayFields: {
        feature: { type: 'text' },
        us: { type: 'text' },
        them: { type: 'text' },
      },
      defaultItemProps: { feature: '', us: '', them: '' },
    },
  },
  defaultProps: {
    title: 'Solution Éco France vs autres mandataires CEE',
    ourLabel: 'Solution Éco France',
    theirLabel: 'Mandataire classique',
    rows: [
      { feature: 'Modèle économique', us: 'Transparent', them: 'Commission souvent opaque' },
      { feature: 'Avance trésorerie artisan', us: '0 €', them: 'Variable / sur facturation' },
      { feature: 'Couverture pôles métiers', us: 'Travaux + Courtage + Mandataire', them: 'Mono-métier' },
      { feature: 'Tableau de bord artisan temps réel', us: 'Inclus', them: 'Rare' },
    ],
  },
  render: ComparisonTable,
};
